 <template>
  <v-main v-if="pagesLoaded">
    <PositionSearch />
    <v-container fluid class="pa-0" v-if="showContent == 'for-employers'">
      <v-card
        elevation="0"
        tile
        color="primary"
        class="hero d-flex align-center"
      >
        <v-container>
          <v-row>
            <div class="subtitle">{{ getPage.subtitle }}</div>
          </v-row>
          <v-row>
            <h1>{{ getPage.title }}</h1>
          </v-row>
        </v-container>
      </v-card>
    </v-container>
    <v-container
      class="content pt-10 pb-10"
      v-if="showContent == 'for-employers'"
    >
      <v-row>
        <v-col cols="12" md="4" v-if="getPage.content.side.length > 0">
          <v-card class="pa-0 ma-0">
            <div class="ml-4 mr-4 pt-4 pb-1">
              <ContentRenderer :content="getPage.content.side" class="mb-4" />
            </div>
          </v-card>
        </v-col>
        <v-col cols="12" md="8">
          <ContentRenderer :content="getPage.content.main" class="columns" />
        </v-col>
      </v-row>
    </v-container>

    <v-container fluid class="pa-0" v-if="showContent == 'about'">
      <v-card
        elevation="0"
        tile
        color="primary"
        class="hero d-flex align-center"
      >
        <v-container>
          <v-row>
            <h1>{{ getPage.title }}</h1>
          </v-row>
          <v-row>
            <div class="subtitle">{{ getPage.subtitle }}</div>
          </v-row>
        </v-container>
      </v-card>
    </v-container>
    <v-container class="content pt-10 pb-10" v-if="showContent == 'about'">
      <v-row>
        <v-col cols="12" md="4" v-if="getPage.content.side.length > 0">
          <ContentRenderer :content="getPage.content.side" />
        </v-col>
        <v-col>
          <ContentRenderer :content="getPage.content.main" />
        </v-col>
      </v-row>
    </v-container>

    <v-container fluid class="pa-0" v-if="showContent !== 'about' && showContent !== 'for-employers'">
      <v-card
        elevation="0"
        tile
        color="primary"
        class="hero d-flex align-center"
      >
        <v-container>
          <v-row>
            <h1>{{ getPage.title }}</h1>
          </v-row>
          <v-row>
            <div class="subtitle">{{ getPage.subtitle }}</div>
          </v-row>
        </v-container>
      </v-card>
    </v-container>
    <v-container class="content pt-10 pb-10"  v-if="showContent !== 'about' && showContent !== 'for-employers'">
      <v-row>
        <v-col cols="12" md="4" v-if="getPage.content.side.length > 0">
          <ContentRenderer :content="getPage.content.side" />
        </v-col>
        <v-col>
          <ContentRenderer :content="getPage.content.main" />
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>
<script>
import PositionSearch from "@/components/PositionSearch.vue";
import ContentRenderer from "@/components/ContentRenderer.vue";

export default {
  name: "Content",
  components: {
    PositionSearch,
    ContentRenderer,
  },
  data(){
    return {
      pagesLoaded: false
    }
  },
  mounted() {
    this.$store.dispatch("dispatchGetPages").then(() => {
      this.pagesLoaded = true;
    });
  },
  computed: {
    showContent() {
      return this.$route.params.id;
    },
    getPage() {
      let page = this.$store.state.pages.find(
        (page) => page.navTitle.toLowerCase().replaceAll(" ", "-") === this.showContent
      );
      if(page == undefined){
        // Page not found, redirect to home
        console.log('page not found');
        this.$router.push('/');
      }
      
      return page;
    },
  },
};
</script>
<style>
.hero {
  min-height: 300px;
}
.content {
  line-height: 170%;
}
h1 {
  font-size: 3rem;
  color: #fff;
  text-transform: uppercase;
}
h2,
h3 {
  color: #002ea1;
  margin-bottom: 1em;
}
h3 {
  margin-top: 0;
}
.author {
  color: #002ea1;
  font-weight: 600;
}
.subtitle {
  color: #fff;
  font-size: 1.2rem;
}
blockquote {
  font-size: 1.2rem;
  font-weight: 600;
  color: #002ea1;
  border-left: 0.5em solid #002ea1;
  padding-left: 1.5em;
}
ul {
  margin-bottom: 2em;
}
.columns {
  column-count: 2;
}
figure table, figure th, figure td{
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-collapse: collapse;
  padding: 0.5em;
}
@media screen and (max-width: 992px) {
  .hero .row {
    justify-content: center;
  }
  .columns {
    column-count: 1;
  }
}
</style>